module.exports = __webpack_public_path__ + "static/10-0919ae315f3dd7cb6987104247c6754f.jpeg";